import React, { createContext, useContext, useState } from 'react';
import { User } from '../../types/users.types';

type SelectedUserContextType = {
  selectedUser: User | null;
  setSelectedUser: (user: User | null) => void;
};

const SelectedUserContext = createContext<SelectedUserContextType>({
  selectedUser: null,
  setSelectedUser: () => {},
});

export const useSelectedUser = () => useContext(SelectedUserContext);

export const SelectedUserProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedUser, setSelectedUser] = useState<User | null>(null);

  return (
    <SelectedUserContext.Provider value={{ selectedUser, setSelectedUser }}>
      {children}
    </SelectedUserContext.Provider>
  );
};